export const SET_USER_DATA = "SET_USER_DATA";
export const USE_2FA = "USE_2FA";
